module.exports = __webpack_public_path__ + "05_short_black.e2e141e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/05_short_black.png
// module id = N5rw
// module chunks = 0